import React, { useState } from "react";
import { Row, Col, Input, DatePicker, Table, Button } from "antd";
import { UserOutlined, RightOutlined, DownOutlined, LoadingOutlined, SyncOutlined } from "@ant-design/icons";
import BackArrow from "../../../assets/images/back_arrow.svg";
import printerIcon from "../../../assets/images/printerIcon.svg";
import Discard from "../../../assets/images/returnIcon.svg";
import data from "../../../constants/retailPos.json";
import { htmlPrint } from "../../../lib/printer/htmlPrinter";
import { xmlPrint } from "../../../lib/printer/xmlPrinter";
import { EditableRow, EditableCell } from "./SalesReturnTable";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useTransactionStore from "../../../stores/useTransactionStore";

const baseOrderHistoryColumns = [
  {
    title: "Document Number",
    dataIndex: "documentno",
    key: "documentno",
    width: "30%",
  },
  {
    title: "Customer",
    dataIndex: "name",
    key: "name",
    width: "28%",
  },
  {
    title: "Total Amount",
    dataIndex: "total",
    key: "total",
    width: "38%",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "19%",
  },
];

const SalesHistoryView = ({
  // order history props
  orderHistorySearchInputRef,
  searchOrderHistory,
  showOrderHistory,
  setOrderHistoryInput,
  changeOrderHistorySearchType,
  orderHistoryDetails,
  selectedKeys,
  handleExpand,
  isPrintModeXML,
  // return-purchase props
  showReturnPurchase,
  setShowReturnPurchase,
  searchReturnHistory,
  dataSource,
  columns1,
  handleSave,
  setModalEditState,
  modalEditState,
  selectedReturnOrder,
  returnProcessLoading,
  setReturnProcessLoading,
  addSelectedReturnProductsToCart,
  returnProcessRef,
  cart,
  productsList,
  setProductsList,
  loader,
  salesHistoryLoading,
}) => {
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const hideAmounts = posConfig?.hideSalesAmountInSalesHistory === "Y";
  const orderHistoryColumns = hideAmounts ? baseOrderHistoryColumns.filter((c) => c.key !== "total") : baseOrderHistoryColumns;
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [docSearchInput, setDocSearchInput] = useState("");

  return (
    <div>
      {!showReturnPurchase ? (
        <>
          <div style={{ display: "flex", padding: "2.6% 3.1% 0 3.1%" }}>
            <div style={{ width: "26%", paddingRight: "2%" }}>
              <label style={{ color: "#000", fontSize: "1.2vw" }}>Customers</label>
              <Input
                ref={orderHistorySearchInputRef}
                placeholder="Search for customers"
                prefix={<UserOutlined style={{ color: "#929098" }} />}
                size="large"
                allowClear={false}
                onPressEnter={(e) => {
                  if (e.target.value.trim() !== "") {
                    searchOrderHistory("customer", e.target.value.trim(), 0, false);
                  }
                }}
                className="salesHistory-input"
                onChange={(e) => {
                  e.target.value === "" ? showOrderHistory() : setOrderHistoryInput(e.target.value);
                  changeOrderHistorySearchType("orderCustomerSearchKey");
                }}
              />
            </div>
            <div style={{ width: "26%", paddingRight: "2%", paddingLeft: "0.3%" }}>
              <label style={{ color: "#000", fontSize: "1.2vw" }}>Date</label>
              <DatePicker
                placeholder="Choose date range"
                size="large"
                allowClear={false}
                open={datePickerOpen}
                onOpenChange={(status) => setDatePickerOpen(status)}
                onChange={(date) => {
                  setDatePickerOpen(false);
                  if (!date) {
                    showOrderHistory();
                    return;
                  }
                  setOrderHistoryInput(date);
                  searchOrderHistory("orderDateSearchKey", [date, date]);
                }}
                className="salesHistory-datePicker"
              />
            </div>
            <div style={{ width: "26%", paddingRight: "2%", paddingLeft: "0.3%" }}>
              <label style={{ color: "#000", fontSize: "1.2vw" }}>Document Number</label>
              <Input
                placeholder="Search document number"
                size="large"
                allowClear={false}
                className="salesHistory-doc-input"
                value={docSearchInput}
                onPressEnter={() => {
                  if (docSearchInput.trim() !== "") {
                    searchOrderHistory("customer", docSearchInput.trim(), 0, false);
                  }
                }}
                onChange={(e) => {
                  const val = e.target.value;
                  setDocSearchInput(val);
                  if (val === "") {
                    showOrderHistory();
                  } else {
                    setOrderHistoryInput(val);
                  }
                  changeOrderHistorySearchType("orderDocumentNo");
                }}
              />
            </div>
            <div style={{ width: "22%", display: "flex", justifyContent: "flex-end", alignItems: "flex-end", paddingRight: "2%" }} />
          </div>
          <Row style={{ padding: "5vh 3.1% 0 3.1%" }}>
            <Table
              style={{ height: "75vh", background: "#F3F4F9", fontSize: "0.9vw", padding: "0 1.5%", borderRadius: "5px" }}
              scroll={{ y: "64vh" }}
              pagination={false}
              loading={{ spinning: loader || salesHistoryLoading, indicator: <LoadingOutlined style={{ fontSize: 28 }} spin /> }}
              columns={orderHistoryColumns}
              dataSource={orderHistoryDetails}
              className="salesHistory-table"
              rowClassName={(record) => (selectedKeys[0] === record.key ? "tableSelectedBlue" : "tableNonSelectedWhite")}
              onExpand={handleExpand}
              expandable={{
                expandedRowRender: (record) => (
                  <div style={{ padding: "1% 4% 1% 4%", backgroundColor: "#fff" }}>
                    <Row>
                      {!hideAmounts && (
                        <Col span={21}>
                          <Row>
                            <Col span={12} className="td-nested-title">
                              Description
                            </Col>
                            <Col span={3} className="td-nested-title" style={{ textAlign: "center" }}>
                              Qty
                            </Col>
                            <Col span={3} offset={1} className="td-nested-title" style={{ textAlign: "center" }}>
                              Unit Price
                            </Col>
                            <Col span={3} offset={1} className="td-nested-title" style={{ textAlign: "center" }}>
                              Net Total
                            </Col>
                          </Row>
                          <Row style={{ paddingBottom: "0.5vw" }}>
                            {record.items.map((e, idx) => (
                              <React.Fragment key={e.lineId || e.name + idx}>
                                <Col span={12} className="td-nested-description">
                                  {e.name}
                                </Col>
                                <Col span={3} style={{ textAlign: "center", fontWeight: "500" }}>
                                  {e.weight}
                                </Col>
                                <Col span={1} style={{ textAlign: "center", fontWeight: "500" }} />
                                <Col span={3} style={{ textAlign: "center", fontWeight: "500" }}>
                                  {e.realPrice.toFixed(2)}
                                </Col>
                                <Col span={1} style={{ textAlign: "center" }} />
                                <Col span={3} style={{ textAlign: "right", paddingRight: "1.5vw", fontWeight: "500" }}>
                                  {(e.realPrice - record.tax).toFixed(2)}
                                </Col>
                              </React.Fragment>
                            ))}
                          </Row>
                          <p style={{ width: "96%", marginLeft: "0%", borderTop: "1.3px solid rgba(52, 40, 44, 0.55)", marginBottom: "0px" }} />
                          <Row style={{ paddingTop: "5px" }}>
                            <Col span={3} offset={17} className="td-subtotal">
                              <span className="td-subTotalText">Subtotal</span>
                              <span className="td-subTotalText">Total tax</span>
                            </Col>
                            <Col span={3} className="td-subtotal" style={{ textAlign: "right", paddingRight: "1.5vw" }}>
                              <span className="td-subTotalText">{record.total - record.tax.toFixed(2)}</span>
                              <span className="td-subTotalText">{record.tax.toFixed(2)}</span>
                            </Col>
                          </Row>
                          <Row style={{ marginBottom: "1%" }}>
                            <Col span={3} offset={17} className="td-subtotal" style={{ padding: "4px 0" }}>
                              <span className="td-total">SALE TOTAL</span>
                            </Col>
                            <Col
                              span={3}
                              style={{ fontSize: "1.1vw", borderBottom: "1px solid rgba(52, 40, 44, 0.55)", textAlign: "right", paddingRight: "1.5vw", paddingTop: "4px" }}
                            >
                              <span className="td-total">{record.total}</span>
                            </Col>
                          </Row>
                        </Col>
                      )}
                      <Col span={hideAmounts ? 24 : 3} className="td-bottons">
                        <p
                          style={{ cursor: "pointer", padding: "5.5% 12%", borderRadius: "3px", border: "1px solid #929098" }}
                          onClick={() => (isPrintModeXML ? xmlPrint(record, "Duplicate Copy") : htmlPrint(record, "Duplicate Copy"))}
                        >
                          <img src={printerIcon} style={{ height: "1.4vw", paddingRight: "0.2vw", cursor: "pointer" }} />
                          Print receipt
                        </p>
                        {parseInt(record.total) > 0 && posConfig?.showSalesReturn === "Y" ? (
                          <p
                            style={{ cursor: "pointer", padding: "5.5% 13%", borderRadius: "3px", border: "1px solid #929098" }}
                            onClick={() => {
                              searchReturnHistory(record.documentno, record);
                              useTransactionStore.getState().setSalesReturn("Y");
                              localStorage.setItem("salesReturn", "Y");
                            }}
                          >
                            <img src={Discard} style={{ height: "1.1vw", paddingRight: "0.4vw" }} />
                            Sales Return
                          </p>
                        ) : null}
                      </Col>
                    </Row>
                  </div>
                ),
                expandIcon: ({ expanded, onExpand, record }) => (
                  <span onClick={(e) => onExpand(record, e)}>{expanded ? <DownOutlined style={{ color: "#929098" }} /> : <RightOutlined style={{ color: "#929098" }} />}</span>
                ),
              }}
            />
          </Row>
        </>
      ) : (
        <div>
          <Row style={{ padding: "1.3% 3.5% 0 1.5%" }}>
            <Col span={1}>
              <img
                src={BackArrow}
                style={data.posScreenStyles.orderHistoryModal.backArrowIcon}
                onClick={() => {
                  if (cart.items.length <= 0) {
                    productsList.map((ele) => {
                      ele.selected = "N";
                    });
                    setProductsList(productsList);
                  }
                  setShowReturnPurchase(false);
                }}
              />
            </Col>
            <Col span={7} style={{ display: "flex", alignItems: "center" }}>
              <span style={{ fontSize: "1.6vw", paddingLeft: "1vw", fontWeight: "500" }}>Return Purchase</span>
            </Col>
          </Row>
          <div style={{ padding: "1.5% 3.5% 0 3%" }}>
            <Row>
              <Table
                className="salesReturn-table"
                dataSource={dataSource}
                pagination={false}
                components={{
                  body: {
                    row: EditableRow,
                    cell: EditableCell,
                  },
                }}
                scroll={{ y: "48vh" }}
                style={{ width: "100%", background: "#F3F4F9", fontSize: "0.9vw", padding: "0 2%", borderRadius: "5px" }}
                setModalEditState={setModalEditState}
                columns={columns1.map((col) => ({
                  ...col,
                  onCell: (record) => ({
                    record,
                    editable: col.dataIndex === "qtyToReturn" && record.product.returnable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                    setModalEditState: setModalEditState,
                  }),
                }))}
              />
            </Row>
            <Row style={{ paddingTop: "4vh" }}>
              <Col span={11} offset={1}>
                <p style={{ fontSize: "1.6vw" }}>Return Items / Qty: </p>
                <p style={{ fontSize: "1.6vw" }}>Return Amount Total:</p>
              </Col>
              <Col span={11} style={{ textAlign: "right" }}>
                <p style={{ fontSize: "1.6vw" }}>
                  {selectedReturnOrder.itemsToReturn ? selectedReturnOrder.itemsToReturn : "0"} /{" "}
                  {selectedReturnOrder.itemsQtyToReturn ? parseFloat(selectedReturnOrder.itemsQtyToReturn).toFixed(2) : "0.00"}
                </p>
                <p style={{ fontSize: "1.6vw" }}>{selectedReturnOrder.returnAmountTotal ? parseFloat(selectedReturnOrder.returnAmountTotal).toFixed(2) : "0.00"}</p>
              </Col>
            </Row>
            <Row style={{ marginTop: "8.3vh" }} gutter={[16]}>
              <Col span={8} />
              <Col span={8} style={{ textAlign: "right" }}>
                <Button
                  style={{ width: "100%", height: "7.5vh", fontSize: "1.6vw", fontWeight: "600", borderColor: "#A4CD38", color: "#A4CD38" }}
                  onClick={() => setShowReturnPurchase(false)}
                  disabled={loader}
                >
                  Remove
                </Button>
              </Col>
              <Col span={8} style={{ textAlign: "right" }}>
                <Button
                  style={{ width: "100%", height: "7.5vh", fontSize: "1.6vw", fontWeight: "600", backgroundColor: "#A4CD38", color: "#fff" }}
                  ref={returnProcessRef}
                  onClick={(e) => {
                    if (!returnProcessLoading && selectedReturnOrder.line.some((each) => each.qtyToReturn > 0)) {
                      setReturnProcessLoading(true);
                      addSelectedReturnProductsToCart(e);
                    }
                  }}
                  disabled={modalEditState || loader}
                  className="focusDashboardCard"
                >
                  Return
                </Button>
              </Col>
            </Row>
          </div>
          {returnProcessLoading && (
            <Col
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
              }}
            >
              <LoadingOutlined style={{ fontSize: 60 }} />
            </Col>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(SalesHistoryView);
